import { Directive, ElementRef, Injector, Input, Output, Inject, SimpleChanges, EventEmitter } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
    selector: 'explore-breakdown-modal-content-wrapper'
})
export class ExploreBreakdownModalContentWrapperDirective extends UpgradeComponent {
    @Input() isOpen: boolean = false;
    @Input() metric: string = '';
    @Input() titledynamic: string = '';
    @Input() subtitledynamic: string = '';
    @Input() icondynamic: string = '';
    @Output() isOpenChange: EventEmitter<boolean> = new EventEmitter();

    close() {
        this.isOpen = false;
        this.isOpenChange.emit(this.isOpen);
    }

    constructor(@Inject(ElementRef) elementRef: ElementRef, @Inject(Injector) injector: Injector) {
        super('exploreBreakdownModalContentWrapper', elementRef, injector);
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/explore/exploreBreakdownModalContentWrapperUpgraded.ts
 **/